export default __webpack_public_path__ + "static/media/project-start.bad711cc.png";